import React, { useEffect, useState } from "react";
import {
  Card,
  Descriptions,
  Tag,
  Button,
  Space,
  Spin,
  Alert,
  Row,
  Col,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import * as tmActions from "store/actions/TenantManagementActions";
import dayjs from "dayjs";

const STATUS_COLORS = {
  active: "green",
  inactive: "default",
  pending: "orange",
  expired: "red",
  cancelled: "default",
};

const TenantSubscriptionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscription = async () => {
      setLoading(true);
      const data = await tmActions.loadSyncedSubscription(id);
      if (data) setSubscription(data);
      setLoading(false);
    };
    fetchSubscription();
  }, [id]);

  if (loading) {
    return <div style={{ padding: "16px", textAlign: "center" }}><Spin size="large" /></div>;
  }

  if (!subscription) {
    return <div style={{ padding: "16px" }}><Alert message="Subscription not found" type="error" /></div>;
  }

  return (
    <div style={{ padding: "16px" }}>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/tenant-management/subscriptions")}>
          Back
        </Button>
        <span style={{ fontSize: 18, fontWeight: 600 }}>
          Subscription: {subscription.plan_name || "N/A"}
          <Tag color={STATUS_COLORS[subscription.status]} style={{ marginLeft: 8 }}>
            {subscription.status}
          </Tag>
        </span>
      </Space>

      <Row gutter={16}>
        <Col span={16}>
          <Card title="Subscription Details">
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Plan Name">{subscription.plan_name || "-"}</Descriptions.Item>
              <Descriptions.Item label="Status">
                <Tag color={STATUS_COLORS[subscription.status]}>{subscription.status}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Amount">₹{parseFloat(subscription.amount).toLocaleString()}</Descriptions.Item>
              <Descriptions.Item label="App">
                <Tag>{subscription.app_connection_name}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Start Date">{subscription.start_date || "-"}</Descriptions.Item>
              <Descriptions.Item label="End Date">{subscription.end_date || "-"}</Descriptions.Item>
              <Descriptions.Item label="External ID"><code>{subscription.external_id}</code></Descriptions.Item>
              <Descriptions.Item label="Last Synced">
                {dayjs(subscription.last_synced_at).format("YYYY-MM-DD HH:mm:ss")}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col span={8}>
          <Card title="Linked Tenant">
            {subscription.tenant_name ? (
              <Descriptions column={1}>
                <Descriptions.Item label="Name">{subscription.tenant_name}</Descriptions.Item>
                <Descriptions.Item>
                  <Button
                    type="link"
                    onClick={() => navigate(`/tenant-management/tenants/${subscription.synced_tenant}`)}
                  >
                    View Tenant Details
                  </Button>
                </Descriptions.Item>
              </Descriptions>
            ) : (
              <p style={{ color: "#888" }}>No linked tenant</p>
            )}
          </Card>

          <Card title="Raw Data" style={{ marginTop: 16 }} size="small">
            <pre style={{ maxHeight: 300, overflow: "auto", fontSize: 12 }}>
              {JSON.stringify(subscription.remote_data, null, 2)}
            </pre>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TenantSubscriptionDetail;
